import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="py-24 bg-emerald-950 relative border-t border-emerald-800/30" data-id="element-158">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-159">
        <FadeIn data-id="element-160">
          <h2 className="text-3xl md:text-5xl font-bold mb-10 text-center" data-id="element-161">
            La industria del fitness fue{' '}
            <span className="text-gradient-gold" data-id="element-162">diseñada por hombres</span>,
            para hombres.
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-163">
          <div className="bg-emerald-900/50 border border-emerald-800/50 p-8 md:p-12 rounded-2xl shadow-xl" data-id="element-164">
            <p className="text-lg md:text-xl text-emerald-50/90 leading-relaxed mb-6 font-body" data-id="element-165">
              Te enseñaron que la disciplina es lineal: "Dale duro todos los
              días". Pero tu cuerpo es cíclico.
            </p>
            <p className="text-lg md:text-xl text-emerald-50/90 leading-relaxed font-body" data-id="element-166">
              Cuando ignoras tus fases hormonales y empujas al máximo durante tu{' '}
              <span className="text-gold-400 font-semibold" data-id="element-167">fase lútea</span>{' '}
              (los días previos a tu periodo), disparas el{' '}
              <span className="text-gold-400 font-semibold" data-id="element-168">cortisol</span>. Tu
              cuerpo entra en modo "supervivencia", bloquea la quema de grasa
              abdominal y activa una{' '}
              <span className="text-gold-400 font-semibold" data-id="element-169">
                inflamación sistémica
              </span>{' '}
              que te hace sentir pesada, hinchada y frustrada. Estás castigando
              a tu metabolismo en lugar de potenciarlo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}